(() => {
  const MOBILE_MAX = 749;
  const getSpaceBetween = () => {
    if (window.innerWidth <= MOBILE_MAX) {
      return (12 * window.innerWidth) / 393;
    }

    const scale = Math.min(1, window.innerWidth / 1440);
    const activeWidth = 588 * scale;
    const inactiveWidth = 282 * scale;
    const gap = 24 * scale;
    return gap - (activeWidth - inactiveWidth) / 2;
  };

  const setup = (root) => {
    if (root.dataset.ammSwiperInitialized === "true" || typeof window.Swiper !== "function") return;

    const viewport = root.querySelector(".amm-2026-swiper__viewport");
    const pagination = root.querySelector(".amm-2026-swiper__pagination");
    const slides = root.querySelectorAll(".amm-2026-swiper__slide");

    if (!viewport || slides.length === 0) return;

    const swiper = new window.Swiper(viewport, {
      slidesPerView: "auto",
      spaceBetween: getSpaceBetween(),
      centeredSlides: true,
      speed: 600,
      loop: slides.length > 2,
      loopedSlides: slides.length,
      grabCursor: true,
      watchOverflow: true,
      slideToClickedSlide: true,
      observer: true,
      observeParents: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
    });

    viewport.addEventListener("click", (event) => {
      const card = event.target.closest(".amm-2026-swiper__card");
      if (!card) return;

      const slide = card.closest(".swiper-slide");
      if (slide && !slide.classList.contains("swiper-slide-active")) {
        event.preventDefault();
      }
    });

    root.querySelectorAll(".amm-2026-swiper__button--prev").forEach((button) => {
      button.addEventListener("click", () => swiper.slidePrev());
    });

    root.querySelectorAll(".amm-2026-swiper__button--next").forEach((button) => {
      button.addEventListener("click", () => swiper.slideNext());
    });

    const handleResize = () => {
      swiper.params.spaceBetween = getSpaceBetween();
      swiper.update();
    };

    window.addEventListener("resize", handleResize);
    root.amm2026Swiper = swiper;
    root.amm2026SwiperResize = handleResize;
    root.dataset.ammSwiperInitialized = "true";
  };

  const init = (root = document, attempts = 0) => {
    const sections = [];

    if (root.matches?.("[data-amm-swiper]")) sections.push(root);
    root.querySelectorAll?.("[data-amm-swiper]").forEach((section) => sections.push(section));

    if (typeof window.Swiper !== "function") {
      if (attempts < 30) {
        window.setTimeout(() => init(root, attempts + 1), 100);
      }
      return;
    }

    sections.forEach(setup);
  };

  const destroy = (root) => {
    if (!root?.amm2026Swiper) return;

    window.removeEventListener("resize", root.amm2026SwiperResize);
    root.amm2026Swiper.destroy(true, true);
    delete root.amm2026Swiper;
    delete root.amm2026SwiperResize;
    root.dataset.ammSwiperInitialized = "false";
  };

  document.querySelectorAll("[data-amm-swiper]").forEach(destroy);

  if (!window.amm2026SwiperSection) {
    document.addEventListener("shopify:section:load", (event) => {
      window.amm2026SwiperSection.init(event.target);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      window.amm2026SwiperSection.destroy(event.target.querySelector?.("[data-amm-swiper]"));
    });
  }

  window.amm2026SwiperSection = { init, destroy };
  init();
})();
